export const dialTimeoutOptions = [
    {
        value: 7,
        label: '7 seconds'
    }, {
        value: 10,
        label: '10 seconds'
    }, {
        value: 15,
        label: '15 seconds'
    }, {
        value: 20,
        label: '20 seconds'
    }, {
        value: 30,
        label: '30 seconds'
    }, {
        value: 45,
        label: '45 seconds'
    }, {
        value: 60,
        label: '60 seconds'
    }, {
        value: 90,
        label: '90 seconds'
    }
]